export default function PageHeader({ title, subtitle, actions, breadcrumb }) {
  return (
    <div className="page-header">
      <div className="page-header-copy">
        {breadcrumb ? <div className="page-breadcrumb">{breadcrumb}</div> : null}
        <div className="section-title section-title-no-margin">{title}</div>
        {subtitle ? <div className="page-subtitle">{subtitle}</div> : null}
      </div>
      {actions ? <div className="page-actions">{actions}</div> : null}
    </div>
  );
}
